import useTutorStore from '../../services/ai_tutor/tutorStore';
import TutorWindow from './components/TutorWindow';

/**
 * AITutorWidget - Global AI Tutor (TutorWindow rendered inside MainLayout)
 * The Nova button lives in the App header.
 */
const AITutorWidget = () => {
  return null;
};

export default AITutorWidget;
